import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../features/posts/postsSlice";
import PostCard from "../components/PostCard";
import Loader from "../components/Loader";

function Home() {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.posts);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  if (loading) return <Loader />;
  if (error) return <p>{error}</p>;

  return (
    <div className="container">
      <h2>Social Media For Travellers</h2>

      <input
  type="text"
  placeholder="Search here..."
  className="search"
/>

      <div className="grid">
        {data.slice(0, 12).map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
}

export default Home;